import { Component, Input } from '@angular/core';
import { MessageService } from 'primeng/api';
import { RequestService } from 'src/app/service/request.service';

@Component({
  selector: 'app-request-table',
  templateUrl: './request-table.component.html',
  styleUrl: './request-table.component.scss',
  providers: [MessageService],
})
export class RequestTableComponent {
  @Input() data: any;
  @Input() view: (id: string | number) => void = () => {};
  // @Input() resend: ((id: string| number) => void)  = ()=>{};
  @Input() loading: boolean | undefined;
  @Input() processLoading: boolean = false;
  newDateTime: any;
  constructor(
    private requestService: RequestService,
    private messageService: MessageService
  ) {

  }
 formatDate(date: string){
  const dateTimeString = date;
  const dateTime = new Date(dateTimeString);
   return dateTime.toLocaleString();
 }

  requestId = {
    _id: '',
  };

  resend(id: string) {
    this.requestService.resendRequest(id).subscribe({
      next: (res: any) => {
        // console.log(res);
        // this.resending = false;
        if (res.statusCode === 200) {
          // this.successmessage = 'Webhook has been resent successfully';
          // this.errormessage = '';
          // console.log('resent successfully');
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Request resent successfully',
          });
          window.location.reload();
        } else {
          // this.successmessage = '';
          // this.errormessage = res.message;
          // console.log(res.message);
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Error resending request',
          });
        }
        setTimeout(() => {
          // this.successmessage = '';
          // this.errormessage = '';
        }, 2000);
      },
      error: (err) => {
        // console.log(err);
        // this.resending = false;
        // this.errormessage = 'Something went wrong. Please try again';
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Error resending request',
        });
        // this.successmessage = '';
        setTimeout(() => {
          // this.successmessage = '';
          // this.errormessage = '';
        }, 3000);
      },
    });
  }

  // resend(id: string) {
  //   this.requestId._id = id;
  //   console.log(this.requestId);
  //   ( this.requestService.resendRequest(this.requestId)).subscribe({
  //     next: (res: any) => {
  //       if(res.statusCode == 200){
  //         console.log('request resent successfully')
  //       }
  //       error: (error: any) => {
  //         console.log('resend failed:', error)
  //       };
  //     },
  //   });
  // }
}
